import axios from "axios";
import { getCookie } from "../utils/cookies";
import { AlertError } from "../utils/componentes-utiles/AlertError";


const baseUrl = 'https://www.s-tecnicos.com/fichajeapp/WS/'



//////////////////////////////tessa management//////////////////////////////////////////////////////
//gets
export const getopcinesMenu = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesmenu.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//trabajadores
export const getTrabajadores = async (idProyecto) => {

    let id = idProyecto ?? 0;

    try {
        const response = await axios.get(baseUrl + 'trabajadores.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                idProyecto: id,
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


//fichajes
export const inicioFichaje = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'fichajes.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postCorregirFichaje = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'corregirFichaje.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const fichajeTotem = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'fichajetotem.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const getFichaje = async (fecha) => {
    try {
        const response = await axios.get(baseUrl + 'fichajes.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                fecha: fecha
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const finFichaje = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'fichajes.php??', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            console.log(response);
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};


export const getTodosFichajes = async (fechaDesde, fechaHasta, usuarios) => {
    try {
        const response = await axios.get(baseUrl + 'allfichajes.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                fechaDesde,
                fechaHasta,
                usuarios
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getTodosFichajesDescarga = async (fechaDesde, fechaHasta, usuarios) => {
    try {
        const response = await axios.post(baseUrl + 'allfichajesdescarga.php', {
            token: getCookie('PHPSESSID'),
            fechaDesde,
            fechaHasta,
            usuarios
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.log('Error en la respuesta del servidor');
            return null;
        }
    } catch (error) {
        console.error('Error al obtener los fichajes para descarga:', error);
        return null;
    }
};
export const getFichajesUsuario = async (mes, year, id) => {
    try {
        const response = await axios.get(baseUrl + 'fichajeUsuario.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                mes: mes,
                year: year,
                id: id
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//recursos humanos
export const getOpcionesRrhh = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesrrhh.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//usuarios
export const getUsuarios = async () => {
    try {
        const response = await axios.get(baseUrl + 'usuarios.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}


export const postUsuario = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'usuario.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }

}

export const delUsuario = async (id) => {
    try {
        const response = await axios.delete(baseUrl + 'usuario.php', {
            data: {
                token: getCookie('PHPSESSID'),
                data: {
                    id: id
                }
            }
        });

        if (response.data.success) {
            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al eliminar el usuario:', error);

        if (error.response) {
            return {
                success: false,
                error: error.response.data?.error || 'Error del servidor'
            };
        } else {
            return {
                success: false,
                error: 'Error de conexión'
            };
        }
    }
};
export const actualizarUsuario = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'usuario.php??', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//administrador
export const getOpcionesAdmin = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesAdministrador.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

//roles y permisos
export const getRolesYDepartamentos = async () => {
    try {
        const response = await axios.get(baseUrl + 'rolesydepartamentos.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}
export const getEmpleadosProyectos = async () => {
    try {
        const response = await axios.get(baseUrl + 'empleadosProyectos.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const actualizarRolesYDepartamentos = async (data, option, rolid) => {
    try {
        const response = await axios.put(baseUrl + 'rolesydepartamentos.php??', {
            token: getCookie('PHPSESSID'),
            option: option,
            rolid: rolid,
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            console.log(response);
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


export const getTareasCalendario = async (token) => {
    try {
        const response = await axios.get(baseUrl + 'tareasCalendario.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getJornadas = async () => {
    try {
        const response = await axios.get(baseUrl + 'jornadas.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const getTodosFichajesAuditoria = async (fechaDesde, fechaHasta, usuarios) => {
    try {
        const response = await axios.post(baseUrl + 'allfichajesauditoria.php', {
            token: getCookie('PHPSESSID'),
            fechaDesde,
            fechaHasta,
            usuarios
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.log('Error en la respuesta del servidor');
            return null;
        }
    } catch (error) {
        console.error('Error al obtener los fichajes para descarga:', error);
        return null;
    }
};

export const putTiempoTrabajadoTarea = async (data, id_tarea) => {
    console.log(data);

    try {
        const response = await axios.put(baseUrl + 'actualizarTiempotrabajadoTarea.php?', {
            token: getCookie('PHPSESSID'),
            data,
            id_tarea: id_tarea

        });
        console.log(response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getVersion = async (versionLocal) => {


    try {
        const response = await axios.get(baseUrl + 'controlVersion.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                versionLocal: versionLocal
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getTodasTareasInfoUnica = async (searchTerm) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'todastareas.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: null,
                tipo: 1,
                fechaDesde: "2000-01-29",
                fechaHasta: "2105-01-29",
                estados: "0,1,2,3,4",
                limit: 100,
                page: 1,
                empleados: null,
                clientes: null,
                proyectos: null,
                searchTerm: searchTerm

            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const getFichajesPendientes = async () => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'fichajesPendientes.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const updateFichajePendiente = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'fichajesPendientes.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }
}

export const updateAnularFichaje = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'anularFichaje.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }
}

export const crearTarjeta = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'creartarjeta.php?', {
            token: getCookie('PHPSESSID'),
            data: data
        });

        if (response.data.success) {
            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al crear la tarjeta:', error);
        return error.response?.data || { success: false, message: error.message };
    }
};

export const getTarjetaPorUsuario = async ({ id_usuario }) => {
    try {
        const response = await axios.get(baseUrl + 'getTarjetaPorUsuario.php', {
            params: {
                token: getCookie('PHPSESSID'),
                id_usuario
            }
        });
        // response.data debería ser { success: true, tarjeta: { ... } } o success:false
        return response.data;
    } catch (error) {
        console.error('Error getTarjetaPorUsuario:', error);
        // mantengo estilo: devolver objeto de error coherente
        return { success: false, message: error.message || 'Error en la petición' };
    }
};


export const getUsuariosSinTarjeta = async () => {
    try {
        const response = await axios.get(baseUrl + 'getUsuariosSinTarjeta.php', {
            params: {
                token: getCookie('PHPSESSID')
            }
        });
        // response.data -> { success: true, data: { usuarios: [...] } }
        return response.data;
    } catch (error) {
        console.error('Error getUsuariosSinTarjeta:', error);
        return { success: false, message: error.message || 'Error en la petición' };
    }
};

export const eliminarTarjeta = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'eliminarTarjeta.php?', {
            token: getCookie('PHPSESSID'),
            data: data
        });

        if (response.data.success) {
            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al eliminar la tarjeta:', error);
        return error.response?.data || { success: false, message: error.message };
    }
};
